module.exports = __webpack_public_path__ + "media/3_Long.1f19af42.mp3";